import React from "react";
import injectSheet from "react-jss";
import DocumentTitle from "react-document-title";
import { useTranslation } from "react-i18next";
import {
  MaxWidthWrapper,
  Headings,
  // IconCheckmark,
  ConstrainWidth,
  P
} from "folksam-ui";

import Layout from "../components/Layout";
import Markdown from "../components/Markdown";
import ViewportPadding from "../components/ViewportPadding";
import { useTrack } from "hooks/useTracking";
// import trekronorlogo from "assets/logo.svg";
import checkPin from "assets/Check-pin.svg";
const styles = ({ theme }) => {
  return {
    root: {
      display: "flex",
      justifyContent: "center",
      margin: [theme.margin.lg, 0]
    },
    heading: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#f35b1c",
      fontFamily: theme.fonts.swedbankHeadlineBlack,
      fontWeight: theme.fontWeights.black
    },
    icon: {
      fill: theme.colors.badgeDone2,
      height: 30,
      width: 30,
      marginRight: theme.padding.sm
    },
    logo: {
      display: "block",
      marginLeft: "auto",
      marginRight: "auto",
      width: 78,
      height: 78,
      marginBottom: theme.margin.md
    },
    box: {
      backgroundColor: "#fbf2ea",
      color: "#512b2b",
      fontFamily: theme.fonts.sans,
      padding: theme.padding.lg
    },
    footer: {
      marginTop: "53px",
      "& p": {
        color: "#512b2b"
      },
      "& h1": {
        fontWeight: theme.fontWeights.normal,
        lineHeight: "54px",
        color: "#f35b1c"
      }
    }
  };
};

const ReceiptPage = ({ classes }) => {
  const { t } = useTranslation();
  const title = t("application.receiptPage.title");
  useTrack(`claim_complete`);

  return (
    <Layout>
      <DocumentTitle title={title} />
      <MaxWidthWrapper>
        <ViewportPadding>
          <div className={classes.root}>
            <ConstrainWidth>
              {/* <Headings.H1 className={classes.heading}>
                <IconCheckmark className={classes.icon} /> {title}
              </Headings.H1> */}
              <div className={classes.box}>
                <img
                  src={checkPin}
                  className={classes.logo}
                  alt={"3kronor logo"}
                />
                <Headings.H3 className={classes.heading}>{title}</Headings.H3>
                <Markdown source={t("application.receiptPage.body")} />
              </div>
              <div className={classes.footer}>
                <P>{t("application.receiptPage.footer.top.paragraph")}</P>
                <Headings.H1>
                  {t("application.receiptPage.footer.header")}
                </Headings.H1>
                <P>{t("application.receiptPage.footer.bottom.paragraph")}</P>
              </div>
            </ConstrainWidth>
          </div>
        </ViewportPadding>
      </MaxWidthWrapper>
    </Layout>
  );
};

export default injectSheet(styles)(ReceiptPage);
